import { render, staticRenderFns } from "./AcessarPedidoItensView.vue?vue&type=template&id=5d1fd5d4"
import script from "./AcessarPedidoItensView.vue?vue&type=script&lang=js"
export * from "./AcessarPedidoItensView.vue?vue&type=script&lang=js"
import style0 from "./AcessarPedidoItensView.vue?vue&type=style&index=0&id=5d1fd5d4&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports